import { render, staticRenderFns } from "./SupplierPart.vue?vue&type=template&id=68a0886c&scoped=true"
import script from "./SupplierPart.vue?vue&type=script&lang=js"
export * from "./SupplierPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a0886c",
  null
  
)

export default component.exports